import { Box, Divider, Typography } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";

import { OrganizationConfiguration, Action } from "./components";
import useCreateOrganization from "./hooks/useCreateOrganization";
import newOrganizationResolver from "../../../../libs/form-validations/organization";
import Breadcrumb from "./components/Breadcrumb";

import { Alert } from "../../../../shared";

const INITIAL_VALUES = {
    Name: "",
    IsActive: true,
};

export default function Create() {
    const { handleCreateOrganization, createOrganizationSvc } = useCreateOrganization();

    const methods = useForm({
        resolver: newOrganizationResolver,
        defaultValues: INITIAL_VALUES,
    });

    const onSubmit = methods.handleSubmit(handleCreateOrganization);

    return (
        <Box flex={1}>
            <Breadcrumb />

            <Divider />

            <Box p={3} pb={0}>
                <Typography level="title-lg">New Organization</Typography>
                <Typography level="body-sm">Enter the details for the new organization.</Typography>
            </Box>
            <Box component={"div"} ml={3} width={700}>
                <FormProvider {...methods}>
                    <form onSubmit={onSubmit}>
                        <Box display={"flex"} gap={2} flexDirection={"column"}>
                            <OrganizationConfiguration />
                            <Action api={createOrganizationSvc} />
                            <Alert
                                successMessage={createOrganizationSvc.isSuccess && "Organization created successfully!"}
                                sx={{ mt: 3 }}
                                errorMessage={
                                    createOrganizationSvc.isError && "Failed to create organization. Please try again."
                                }
                            />
                        </Box>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
